<template>
  <nav class="flex items-center text-md text-[#333] mb-16">
    <span class="mr-2"><i class="fa-solid fa-home"></i></span>
    <ul class="flex space-x-2 items-center">
      <!-- <li class="cursor-pointer hover:underline">Home</li>
      <li>&gt;</li> -->
      <li class="cursor-pointer hover:underline" @click="naviToProducts('p')">
        Products
      </li>
      <li class="text-gray-300">&gt;</li>
      <li class="cursor-pointer hover:underline" @click="naviToProducts('pl')">
        {{ ptitle }}
      </li>
      <li v-if="dtitle" class="text-gray-300">&gt;</li>
      <li v-if="dtitle" class="text-lime-600 font-medium cursor-default">
        <!-- General Purpose Silicone Rubber For Molding (Precipitated/Fumed) -->
        {{ dtitle }}
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'PNaviBar',
  components: {},
  props: ['ptitle', 'dtitle'],
  watch: {
    // ptitle: {
    //   handler(val) {
    //     if (val) {
    //       if (val === 'LSR') {
    //         this.list = this.LSR
    //         this.ptitle = 'LSR Silicone Rubber'
    //       } else {
    //         this.list = this.HTV
    //         this.ptitle = 'HTV Silicone Rubber'
    //       }
    //     }
    //   },
    //   immediate: true
    // }
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    naviToProducts(page) {
      let params = {}
      switch (page) {
        case 'p':
          params = {
            path: '/products',
            query: {
              i: 'rK6w6tH26Z'
            }
          }
          break
        case 'pl':
          params = {
            path: '/products',
            query: {
              i: 'btEHNsnQ'
            }
          }
          break
      }
      this.$router.push(params)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/Products/NaviBar.vue